import { message } from 'antd'

const SuccessMessage = description => {
  message.config({
    duration: 1,
    maxCount: 1,
  })
  message.success({
    content: description,
    className: 'custom-class',
    style: {
      zIndex: 99999,
      marginTop: '50px',
      color: '#010E30',
      borderLeft: '5px solid #52c41a',
      transitionDuration: '1s',
    },
  })
}

export default SuccessMessage
